module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "explainWhy"
    }
  }, [_c('h1', [_vm._v("为什么会出现“存入零钱”？")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("当用户本年度用量超出标准范围后，应当补交相应的阶梯差价。阶梯差价根据超出度数不同，则差价不同，有时会是整数，有时会带有小数。因电表暂不支持充值小数金额，所以当自动扣除差价时，系统会自动进位到整数位进行扣除。那么多扣用户的那部分小数金额会以“零钱”的方式补充到您的APP中。这部分零钱累计满1元时，会自动充值到您的电表中。")]), _vm._v(" "), _c('el-collapse', {
    staticStyle: {
      "margin-top": "30px"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.activeNames),
      callback: function($$v) {
        _vm.activeNames = $$v
      },
      expression: "activeNames"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "举例说明：",
      "name": "1"
    }
  }, [_c('p', [_vm._v("补交阶梯差价 = 1.5元")]), _vm._v(" "), _c('p', [_vm._v("充值缴费金额 = 100元")]), _vm._v(" "), _c('p', [_vm._v("系统自动抵扣差价 = 2.0元")]), _vm._v(" "), _c('p', [_vm._v("存入零钱 = 系统自动抵扣差价-补交阶梯差价")]), _vm._v(" "), _c('p', [_vm._v("即：存入零钱 = 0.5元")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-de870b06"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/explainWhy.vue
// module id = 554
// module chunks = 1